export default {
  data () {
    return {
      $_refresh_token: null
    }
  },

  computed: {
    $_refresh_interval () {
      return 5000   
    },

    $_refresh_allowed () {
      return true
    }
  },
  
  methods: {
    $_refresh () {
      console.log('Refreshing...')
    }
  },

  mounted () {
    this.$_refresh_token = setInterval(() => {
      if (this.$_refresh_allowed) {
        this.$_refresh()
      }
    }, this.$_refresh_interval)
  },

  destroyed () {
    clearInterval(this.$_refresh_token)
  },
}